import { createFileRoute } from "@tanstack/react-router";
import HowManyTmsSessions from "@/pages/articles/HowManyTmsSessions";
export const Route = createFileRoute("/how-many-tms-sessions")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Many TMS Sessions | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How many TMS sessions will you need? Compare standard TMS, SAINT TMS, and SPRAVATO treatment schedules in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "How Many TMS Sessions | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How many TMS sessions will you need? Compare standard TMS, SAINT TMS, and SPRAVATO treatment schedules in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-many-tms-sessions",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-many-tms-sessions",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowManyTmsSessions />;
}
